<template>
  <p class="alert alert-danger text-center">No Data Found!</p>
</template>

<script>
export default {};
</script>

<style scoped>
p {
  margin: 15px 0 !important;
}
</style>
